(function (jq, dell) {
    dell.Components = dell.Components || {};
    dell.Components.RecentlyViewedProducts = dell.Components.RecentlyViewedProducts || {};
    (function () {

        this.createRvpsHtml = (response) => {
            dell.Components.RecentlyViewedProducts.resposne = response;
            let recentlyViewedList = response.RecentlyViewedList;
            let cmsContent = response.CMSContent;
            let i = 0, j;
            var html = '';
            for (i = 0, j = recentlyViewedList.length; i < j; i++) {
            html = html + `<div class="slide"><div><div class="js-additional-product mb-10"><span class="badge badge-pill badge-success mb-2"> ${cmsContent.RecentlyViewedHeader}</span><a class="product-close float-md-right cursor-pointer" style="border:1px solid #FFF;">
                                <svg class="dti" onclick="Dell.Components.RecentlyViewedProducts.removeProduct('${recentlyViewedList[i].EncryptServiceTag}','${recentlyViewedList[i].IsTag}','${recentlyViewedList[i].ProductCode}','${recentlyViewedList[i].TagId}','${recentlyViewedList[i].IsEmcProduct}','${(recentlyViewedList[i].SerialNumber === undefined || recentlyViewedList[i].SerialNumber === null) ? '' : recentlyViewedList[i].SerialNumber}','${response.AppName}', event)">
                                    <svg style="position:absolute; z-index:9999" id="dt-close" style="z-index:9999; position:absolute;" viewBox="0 0 32 32" width="100%" height="100%"><path d="M28.971 4.361l-1.331-1.331-11.637 11.637-11.56-11.561-1.331 1.331 11.56 11.561-11.484 11.484 1.331 1.331 11.484-11.484 11.561 11.56 1.331-1.331-11.561-11.56z"></path></svg></svg></a>
                                 <div class="d-flex"><div class="product-image mr-2"><a href="${recentlyViewedList[i].TargetUrl}" onclick="Dell.Components.RecentlyViewedProducts.rvpsCallBack('${recentlyViewedList[i].ServiceTag}','${recentlyViewedList[i].IsTag}','${recentlyViewedList[i].ProductCode}','${recentlyViewedList[i].EncryptServiceTag}','${recentlyViewedList[i].IsEmcProduct}','${recentlyViewedList[i].SerialNumber}');">
                                    <img src="${recentlyViewedList[i].ImagePath !== null && recentlyViewedList[i].ImagePath !== '' ? recentlyViewedList[i].ImagePath : cmsContent.EmptyImageUrl }" title="${recentlyViewedList[i].ProductName}" /></a>
                                </div><div><a href="${recentlyViewedList[i].TargetUrl}" onclick="Dell.Components.RecentlyViewedProducts.rvpsCallBack('${recentlyViewedList[i].ServiceTag}','${recentlyViewedList[i].IsTag}','${recentlyViewedList[i].ProductCode}','${recentlyViewedList[i].EncryptServiceTag}','${recentlyViewedList[i].IsEmcProduct}','${recentlyViewedList[i].SerialNumber}');">
                                      ${recentlyViewedList[i].ProductName !== null && recentlyViewedList[i].ProductName !== '' ? recentlyViewedList[i].ProductName : '' }</a>
                                    ${(() => {
                                            if (recentlyViewedList[i].IsEmcProduct && recentlyViewedList[i].SerialNumber !== null && recentlyViewedList[i].SerialNumber !== '') {
                                                return `<p class="text-graphite mb-0">${cmsContent.ProductCode}: ${recentlyViewedList[i].SerialNumber}</p>`;
                                            }
                                            else if (recentlyViewedList[i].IsTag) {
                                                return `<p class="text-graphite mb-0">${cmsContent.ServiceTag} ${recentlyViewedList[i].ServiceTag}</p>`;
                                            }
                                            else {
                                                return ``;
                                            }
                                        })()}
                                    
                                </div>
                            </div>
                        </div>
                    </div></div>`;

            }
            return html;
            //// Empty slide used to allow last slide to be in full view
            //this.renderView(`<div class="slide"><div class="d-none js-additional-product"></div></div>`);
        };

        this.renderView = (html) => {
            $('#supportAssistWidget').slick('slickAdd', html);
        };

        var createRvpsHtmlString = this.createRvpsHtml;

        this.getRVPS = () => {
            let urlPath = this.Url();
            let url = `${urlPath.baseUrl}/${urlPath.getRVPS}`;
            this.makeAjaxCall(url, "GET")
                .done(function (response) {
                    let htmltstring = createRvpsHtmlString(response);
                    renderView1(htmltstring);
                }).fail(function () {
                    console.log('rvps api failed');
                });
        };

        this.Url = () => {
            if (Dell.OnlineUtils !== 'undefined' && Dell.OnlineUtils.Lwp !== 'undefined') {
                let baseUrl = 'https://www.dell.com/support/components';
                if (Dell.ComponentLoader.baseUrls !== undefined && Dell.ComponentLoader.baseUrls["rvpsApi"]) {
                    baseUrl = Dell.ComponentLoader.baseUrls["rvpsApi"];
                }
                let urls = {
                    baseUrl: baseUrl,
                    getRVPS: 'rvps/getrvps?appName=' + Dell.ComponentLoader.appNames["rvps"],
                    removeRVPS: 'rvps/removervps'
                };
                return urls;
            }
            return '';
        };


        this.makeAjaxCall = (url, methodType, data) => {
            let ajaxData = {
                url: url,
                method: methodType,
                dataType: "json",
                cache: false,
                contentType: "application/json;",
                async: true
            };

            if (data !== undefined || data !== null) {
                ajaxData.data = data;
            }

            if (url.indexOf("//.dell.com") === -1) {
                ajaxData.xhrFields = {
                    withCredentials: true
                };
            }

            return jq.ajax(ajaxData);
        };

        var renderView1 = this.renderView;

        this.rvpsCallBack = (serviceTag, isTag, productCode, encryptServiceTag, isEmcProduct, serialNumber) => {
            let callBackFuncname = "window.RVPSCallBack";
            if (eval("typeof " + callBackFuncname) !== "undefined") {
                let callBackFun = eval(callBackFuncname);
                let data = {
                    "serviceTag": serviceTag,
                    "isTag": isTag,
                    "productCode": productCode,
                    "encryptServiceTag": encryptServiceTag,
                    "isEmcProduct": isEmcProduct,
                    "serialNumber": serialNumber
                };
                let returnObj = callBackFun.call(this, data);
                if (returnObj !== undefined && returnObj === false) {
                    event.preventDefault();
                }
            }
        };

        this.removeProduct = (serviceTag, isTag, productCode, tagId, isEmcProduct, serialNumber, source, event) => {
            console.log(event)
            let urlPath = this.Url();
            let url = `${urlPath.baseUrl}/${urlPath.removeRVPS}`;
            let data = {
                "ServiceTag": serviceTag,
                "IsTag": isTag,
                "ProductCode": productCode,
                "IsEmcProduct": isEmcProduct,
                "serialNumber": serialNumber,
                "TagId": tagId,
                "Source": source
            };

            let railview = `<div class="d-flex mt-7" aria-busy="true" aria-described-by="system-detect-progress"><div class="skeleton image-skeleton rounded-sm mr-4"></div><div><div class="skeleton text-skeleton rounded-sm mb-2"></div><div class="skeleton text-skeleton rounded-sm"></div></div></div>`;

            $('.slick-current').addClass('js-product-rvps-rpps-skeleton');
            let currentView = $('.slick-current')[0].innerHTML;
            $('.slick-current')[0].innerHTML = railview;
            $('.slick-prev').addClass('slick-arrow-remove');
            $('.slick-next').addClass('slick-arrow-remove');
            this.makeAjaxCall(url, "POST", JSON.stringify(data))
                .done(function(response) {
                    Dell.Components.RecentlyViewedProducts.removCurrentSlide();
                    Dell.Components.RecentlyViewedProducts.checkAndRemoveEmptySlide();
                    Dell.Components.RecentlyViewedProducts.checkAndHideIntegratedRvpsDiv();
                }).fail(function() {
                    $('.slick-current')[0].innerHTML = currentView;
                    console.log('rvps api failed');
                }).always(function() {
                    $('.slick-prev').removeClass('slick-arrow-remove');
                    $('.slick-next').removeClass('slick-arrow-remove');
                    $('.slick-current').removeClass('js-product-rvps-rpps-skeleton');
                });
        };

        this.removCurrentSlide = () => {
            // Get total number of slides
            let slides = $('#supportAssistWidget .slide');
            let currentSlide = $('#supportAssistWidget').slick('slickCurrentSlide');

            // If slickCurrentSlide === totalSlides - 2
            // after removing, run slickPrev()
            if (currentSlide === slides.length - 2) {
                $('.slick-container').slick('slickRemove', currentSlide);
                $('#supportAssistWidget').slick('slickPrev');
            } else {
                $('.slick-container').slick('slickRemove', currentSlide);
            }
            
        };
        this.checkAndRemoveEmptySlide = () => {
            // Get total number of slides
            let emptySlide = $('#divemptyslidervps');
            let slideCount = $('#supportAssistWidget').slick("getSlick").slideCount;

            if (slideCount === 2 && emptySlide.length === 1) {
                $('.slick-container').slick('slickRemove', 1);
                Dell.Components.RecentlyViewedProducts.reInitSlick();
            }
        };

        this.checkAndHideIntegratedRvpsDiv = () => {
            // Get total number of slides
            let slideCount = $('#supportAssistWidget').slick("getSlick").slideCount;

            if (slideCount === 0) {
                $('.detect-pc-widget').css('display', 'none');

                let callBackFuncName = "window.EmptyDetectPcWidget";
                if (eval("typeof " + callBackFuncName) !== "undefined") {
                    let callBackFun = eval(callBackFuncName);
                    callBackFun.call(this, null);
                }
            }
        };

        this.reInitSlick = () => {
            $('#supportAssistWidget').slick('slickRemove', 1);
            $('#supportAssistWidget').slick('unslick');
            $('#supportAssistWidget').on('init',
                function () {
                    $('#supportAssistWidget').fadeIn(1000);
                }).slick({
                    speed: 300,
                    slidesToShow: 2,
                    variableWidth: true,
                    infinite: false,
                    centerMode: true,
                    nextArrow: `<button type="button" class="slick-next"><svg class="dti dti-lg"><svg viewBox="0 0 32 32"><path d="M9.96 1.922l-1.331 1.333 12.745 12.745-12.745 12.745 1.331 1.333 14.078-14.078z"></path></svg></svg></button>`,
                    prevArrow: `<button type="button" class="slick-prev"><svg class="dti dti-lg"><svg viewBox="0 0 32 32"><path d="M23.371 3.255l-1.331-1.333-14.078 14.078 14.078 14.078 1.331-1.333-12.745-12.745z"></path></svg></svg></button>`
                });
        };

    }).apply(dell.Components.RecentlyViewedProducts);
})(jQuery, Dell = window.Dell || {});